import { intlTelInput } from "@intl-tel-input/react/with-utils";

export const DEFAULT_COUNTRY = "jp";

const JAPAN_DIAL_CODE = "+81";

/**
 * 国際表記は国内プレフィックスの 0 を落として +81 80-1111-1111 になるが、
 * 日本では 080-1111-1111 と書くのが普通なので、日本の番号だけは
 * 国番号と国内表記を並べて +81 080-1111-1111 と見せる。
 */
export const formatPhoneNumber = (phoneNumber: string): string => {
  const { utils } = intlTelInput;
  if (utils === undefined) {
    // with-utils から読み込んでいるので undefined にはならない
    return phoneNumber;
  }
  if (phoneNumber.startsWith(JAPAN_DIAL_CODE)) {
    const nationalFormat = utils.formatNumber(
      phoneNumber,
      DEFAULT_COUNTRY,
      "NATIONAL"
    );
    return `${JAPAN_DIAL_CODE} ${nationalFormat}`;
  }
  // 国番号を含む番号なので iso2 は渡さなくてよい
  return utils.formatNumber(phoneNumber, undefined, "INTERNATIONAL");
};

const VISIBLE_DIGIT_COUNT = 4;

/**
 * 登録済みの番号は下4桁だけを見せる。区切りと桁数は残すので、
 * 自分がどの番号を登録したかは見分けられる。
 *
 * formatPhoneNumber が整えた表記を受け取る前提で、区切り以外の文字
 * (国番号の + など)もまとめて隠す。
 */
export const maskPhoneNumber = (formattedPhoneNumber: string): string => {
  const separators = [" ", "-"];
  const digitCount = (formattedPhoneNumber.match(/\d/g) ?? []).length;
  let seenDigits = 0;
  return formattedPhoneNumber
    .split("")
    .map((character) => {
      if (separators.includes(character)) {
        return character;
      }
      if (!/\d/.test(character)) {
        return "*";
      }
      seenDigits += 1;
      return seenDigits > digitCount - VISIBLE_DIGIT_COUNT ? character : "*";
    })
    .join("");
};
